export default [
  // {
  //   title: 'Fraud Rules',
  //   group: 'rules',
  //   component: 'rules',
  //   section: 'system',
  //   order: 2,
  //   icon: 'security'
  // }
]
